import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.button`
  ${({ theme }) => css`
    font-size: 17px;
    font-weight: ${theme.font.bold};
    border: 1px solid ${theme.colors.white};
    background: #00995D;
    border-radius: ${theme.border.xradius};
    min-width: 3rem;
    color: ${theme.colors.white};
    padding: 0.8rem;
    width: 100%;
    cursor: pointer;
    transition: ${theme.transition.default};
    ${media.lessThan('small')`
        font-size: 9px;
        svg{
          width: ;
        }
      `}
    &:hover {
      outline: none;
    }
    :disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `}
`
